import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Slide, ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";

import packageInfo from './../package.json';
import Dashboard from "./pages/Dashboard";
import Protected from "./routes/Protected";
import AuthContexProvider from "./context/AuthContext";
import Layout from "./pages/Layout";
import Page404Error from "./pages/Page404Error";
import Lock from "./pages/Lock";
import MenuContextProvider from "./context/MenuContext";
import Transactions from "./pages/Transactions";
import PublicRoute from "./routes/PublicRoute";
import moment from "moment";
import axios from "axios";
import Accounts from "./pages/Accounts";
import Users from "./pages/Users";
import Installations from "./pages/Installations";
import Inactive from "./pages/Inactive";
import Subscriptions from "./pages/Subscriptions";
import Unauthorize from "./pages/Unauthorize";
import TransactionsErrors from "./pages/TransactionsErrors";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/">
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<Lock />} />
      </Route>
      <Route element={<Protected />}>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/customers/accounts" element={<Accounts />} />
          <Route path="/customers/users" element={<Users />} />

          <Route path="/activities/installations" element={<Installations />} />
          <Route path="/activities/subscriptions" element={<Subscriptions />} />
          <Route path="/activities/transactions" element={<Transactions />} />
          <Route path="/activities/transactions-errors" element={<TransactionsErrors />} />

          <Route path="/reports/inactive" element={<Inactive />} />
          <Route path="/reports/unauthorize" element={<Unauthorize />} />
        </Route>
      </Route>
      <Route path="*" element={<Page404Error />} />
    </Route>
  )
);

const App = () => {
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(false);

  useEffect(() => {
    console.info(
        `%c🚀 FluidApps Prod v${packageInfo.version} %c Initializing... `,
        "color: white; background: #6847b2; font-weight: bold; border-radius: 3px 0 0 3px;",
        "color: #6847b2; background: #f1f5f9; font-weight: bold; border-radius: 0 3px 3px 0;"
      );

    const session = sessionStorage.getItem("sess")
      ? JSON.parse(sessionStorage.getItem("sess")!)
      : undefined;
    if (session) {
      const dateExpiry: string = moment(session.expiry).format("X");
      const dateTimeNow: string = moment().format("X");
      if (dateTimeNow < dateExpiry) {
        sessionStorage.setItem(
          "sess",
          JSON.stringify({
            ...session,
            date: dateTimeNow,
          })
        );
        setToken(true);
      } else {
        sessionStorage.removeItem("sess");
        setToken(false);
      }
    } else {
      sessionStorage.removeItem("sess");
      setToken(false);
    }
    setLoading(false);
  }, []);

  return (
    <>
      {!loading ? (
        <AuthContexProvider initialData={token}>
          <MenuContextProvider>
            <ToastContainer
              position="bottom-center"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              transition={Slide}
            />
            <RouterProvider router={router} />
          </MenuContextProvider>
        </AuthContexProvider>
      ) : (
        <h1>Loading</h1>
      )}
    </>
  );
};

export default App;
